import axios from 'axios';
import { getBuildNumber, getVersion } from 'react-native-device-info';
import { isNetworkAvailable } from '../../hooks/useConnection';
import { useProfileStore } from '../../store/useProfileStore';
import { handleRetry } from '../../utils/handleRetry';
import { getQnAURI } from '../paths';
import { Platform } from 'react-native';
import { webBuildNumber } from '@ninjacart/nc-nk-core';

export const axiosQnAClient = axios.create({
  baseURL: getQnAURI(),
  timeout: 60000,
  headers: {
    Accept: 'application/json',
    'x-build-number': Platform.OS === 'web' ? webBuildNumber : Number(getBuildNumber()),
    'x-platform': Platform.OS,
    'x-version-code': getVersion(),
    ...(useProfileStore.getState().userProfile?.access_token && {
      Authorization: `Bearer ${useProfileStore.getState().userProfile?.access_token}`,
    }),
    ...(useProfileStore?.getState()?.userProfile?.user?.id && {
      'x-nc-system-user-id': useProfileStore?.getState()?.userProfile?.user?.id,
    }),
    ...(Platform.OS !== 'web' && { 'Accept-Encoding': 'gzip' }),
  },
});

axiosQnAClient.interceptors.request.use(async (config) => {
  //TODO: Sometimes access token is undefined if business name api fails or exchange token api fails. Need to debug this
  const isConnected = isNetworkAvailable();
  if (!isConnected) {
    console.log('Network in not connected!!!');
    return Promise.reject('No internet available!!!');
  }

  if (useProfileStore?.getState()?.userProfile?.access_token) {
    config.headers.Authorization = `Bearer ${useProfileStore.getState().userProfile?.access_token}`;
  }

  if (useProfileStore?.getState()?.userProfile?.user?.id) {
    config.headers['x-nc-system-user-id'] = `${useProfileStore.getState().userProfile?.user?.id}`;
  }

  const isExpert = hasExpertRole();
  if (isExpert) {
    config.headers['x-nc-user-scopes'] = isExpert;
  }
  return Promise.resolve(config);
});

const hasExpertRole = (): string | undefined => {
  const pickRole = useProfileStore.getState()?.userRoles.find((x) => x === 'mods');
  if (pickRole) {
    return pickRole;
  }
  return undefined;
};

axiosQnAClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const config = error.config;
    return handleRetry(error, config, 'AXIOS_QNA_CLIENT_API_FAILED', axiosQnAClient);
  }
);
